<div class="flex-container">
  <div class="inner">
    <div class="title">
      {{
        'providerIntegration.appleIntegration.welcome'
          | translate: { name: bizName }
      }}
    </div>
    <div class="info">
      {{ 'providerIntegration.appleIntegration.selectBotInfo' | translate }}
    </div>
    @if (bizLogo) {
      <div><img [ngSrc]="bizLogo" width="250" height="250" /></div>
    }

    <div class="select-bot-section">
      <div class="bot-connect">
        {{ 'providerIntegration.appleIntegration.botToConnect' | translate }}
      </div>
      <div>
        @if (bots) {
          <app-selector
            [values]="bots"
            [label]="
              'providerIntegration.appleIntegration.selectOneOfYourBots'
                | translate
            "
            [emptyLabel]="
              'providerIntegration.appleIntegration.selectOneOfYourBots'
                | translate
            "
            valueLabel="name"
            (selectValue)="onSelectBot($event)"
          >
          </app-selector>
        }
      </div>
      @if (showSelectBotError) {
        <div class="bot-error">
          <mat-icon class="error-icon">error</mat-icon
          >{{
            'providerIntegration.appleIntegration.selectBotError' | translate
          }}
        </div>
      }
      <app-button
        color="primary"
        [text]="'providerIntegration.appleIntegration.connect' | translate"
        size="m"
        (btnClick)="connect()"
      ></app-button>
    </div>
  </div>
</div>
